import { Outlet, NavLink, Link } from "react-router-dom";
import logo from "../assets/logo.jpg";

export default function Layout() {
  return (
    <>
      <div className="pilot-banner">
        Pilot program now open in the USA &amp; Canada
        <Link to="/pilot">Sign up &rarr;</Link>
      </div>
      <header className="site-header">
        <div className="inner">
          <Link to="/" className="brand">
            <img src={logo} alt="MyJava.ai logo" />
            <span className="brand-text">MyJava.ai</span>
          </Link>
          <nav className="site-nav" aria-label="Primary">
            <NavLink to="/" end>Home</NavLink>
            <NavLink to="/about-us">About Us</NavLink>            <NavLink to="/pilot">Pilot</NavLink>
          </nav>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="inner">
          <div>&copy; {new Date().getFullYear()} MyJava.ai &mdash; Conversations that connect.</div>
          <div>
            <Link to="/about-us">About</Link>
            {" · "}
            <Link to="/pilot">Join the pilot</Link>
          </div>
        </div>
      </footer>
    </>
  );
}
